import { Component, inject } from '@angular/core';
import { NxLabelModule } from '@aposin/ng-aquila/base';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { TranslateModule } from '@ngx-translate/core';

import UserService from '#services/user/user.service';

@Component({
  template: `<div data-testid="user-unavailable-modal">
    <div class="flex justify-center mb-3.5">
      <nx-icon style="color: var(--danger)" name="exclamation-circle-o" aria-hidden="true" size="l" />
    </div>
    <h3 class="text-center" nxHeadline size="m">{{ 'user-unavailable.title' | translate }}</h3>
    @if (getGadId(); as gadId) {
      <nx-label class="nx-margin-s text-center">
        {{ 'user-unavailable.message' | translate: { gadId } }}
      </nx-label>
    }
    <div class="flex justify-center mt-7">
      <button (click)="data.reload()" nxButton="small-medium" type="button">
        {{ 'user-unavailable.reload' | translate }}
      </button>
    </div>
  </div>`,
  imports: [NxHeadlineModule, NxButtonModule, NxIconModule, NxLabelModule, TranslateModule],
})
export class UserUnavailableModalComponent {
  readonly data = inject<{
    reload: () => void;
  }>(NX_MODAL_DATA);

  private readonly userService = inject(UserService);

  protected getGadId() {
    return this.userService.getGadId();
  }
}
